export const DATA_COLUMN_PROPS = {
  data: { // 面板数据。支持双向绑定
    type: Array,
    default: () => ([])
    /*
      [
        {
          label: string / slot,
          value: string / slot, // 加解密场景。。。
          checked: boolean, // 是否选中，单选以及多选
        }
      ]
    */
  },
  draggedId: String, // 唯一值。在使用拖拽后。想下次使用拖拽后的顺序。则必须使用该值关联历史拖拽的数据。 query-table默认使用 url
  layoutModel: { // 布局的模式
    type: String,
    default: 'single' // single（单行：超过一行 放到更多里面/或者左右滑动） flat（平铺，换行展示）
  },
  showCheckbox: {
    type: Boolean,
    default: false
  },
  height: {
    type: Number,
    default: 30
  },
  cellWrapClassName: String,
  selectMode: String, // 单选的模式 none 无 single 单选  multiple 多选v
  draggable: {
    type: Boolean,
    default: true
  },
  morePopoverAttrs: {
    type: Object,
    default: () => ({})
  },
  customMoreOption: [Function, Object],
  draggedPriorityElevation: {
    type: Boolean,
    default: true
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/props/index.js